<template>
  <div class="login-container">
    <div class="background-overlay"></div>
    <div class="login-content">
      <el-form 
        :model="form" 
        :rules="rules" 
        ref="loginForm" 
        class="login-form"
        label-position="top"
      >
        <h2 class="form-title">欢迎登录</h2>
        
        <el-form-item prop="username">
          <el-input 
            v-model="form.username" 
            placeholder="用户名"
            prefix-icon="el-icon-user"
          ></el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input 
            v-model="form.password" 
            type="password" 
            placeholder="密码"
            prefix-icon="el-icon-lock"
            show-password
          ></el-input>
        </el-form-item>

        <el-form-item prop="captcha" class="captcha-item">
          <div class="captcha-wrapper">
            <el-input
              v-model="form.captcha"
              placeholder="验证码"
              prefix-icon="el-icon-picture"
              style="flex: 1; margin-right: 10px;"
            ></el-input>
            <img 
              :src="captchaUrl" 
              @click="refreshCaptcha" 
              class="captcha-image"
              alt="验证码"
            >
          </div>
        </el-form-item>

        <el-button 
          type="primary" 
          @click="submitForm" 
          class="login-btn"
          :loading="loading"
        >
          {{ loading ? '登录中...' : '立即登录' }}
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { login, captcha } from '../api/auth'

export default {
  data() {
    return {
      form: {
        username: '',
        password: '',
        captcha: ''
      },
      captchaUrl: '',
      captchaId: '',
      loading: false,
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.refreshCaptcha()
  },
  methods: {
    refreshCaptcha() {
      captcha().then(res => {
        this.captchaUrl = res.data.image
        this.captchaId = res.data.captcha_id
      }).catch(error => {
        this.$message.error('验证码获取失败')
        console.error('验证码获取失败:', error)
      })
    },
    submitForm() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          login({
            username: this.form.username,
            password: this.form.password,
            captcha_id: this.captchaId,
            captcha: this.form.captcha
          }).then(res => {
            if (res.code == 1) {
              localStorage.setItem('token', res.data.token)
              localStorage.setItem('username', res.data.username)
              this.$router.push('/home')
              this.$message.success('登录成功')
            }
          }).catch(err  => {
            this.refreshCaptcha()
            this.$message.error(err.error)
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('~@/assets/login_bg.png');
  background-size: cover;
  background-position: center;
  position: relative;
}

.background-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.login-content {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 450px;
  padding: 0 20px;
}

.login-form {
  background: rgba(255, 255, 255, 0.95);
  padding: 40px 30px;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.form-title {
  text-align: center;
  color: #303133;
  margin-bottom: 30px;
  font-size: 24px;
  font-weight: 500;
}

.login-btn {
  width: 100%;
  margin-top: 15px;
  height: 44px;
  font-size: 16px;
}

.captcha-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
}

.captcha-image {
  height: 40px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  cursor: pointer;
  transition: all 0.3s;
}

.captcha-image:hover {
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .login-form {
    padding: 30px 20px;
    margin: 0 15px;
  }

  .form-title {
    font-size: 20px;
    margin-bottom: 25px;
  }

  .el-input__inner {
    height: 44px !important;
  }

  .login-btn {
    height: 42px;
    font-size: 15px;
  }
}
</style>